<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-layout pt-4 wrap justify-left>
      <v-flex xs12 xl11 px-2>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs5 sm3 md3 lg2 xl2>
            <v-layout wrap justify-center>
              <v-flex xs3 sm2 text-left align-self-center>
                <!-- <v-img
                  src="./../../../assets/icon.png"
                  contain
                  height="15px"
                ></v-img> -->
              </v-flex>
              <v-flex xs9 sm10 text-left pl-2 align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Inventory
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex xs12 xl11>
            <SubCategorySlider />
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="products.length > 0" pt-6>
          <v-flex xs12 xl11>
            <v-card flat outlined style="border-radius: 12px; border: 1px solid #eaeaea; background: #fff;">
              <!-- Table Header -->
              <div class="hidden-sm-and-down" style="padding: 16px 24px; border-bottom: 1px solid #eaeaea; background-color: #fafafa; border-radius: 12px 12px 0 0;">
                <v-layout wrap justify-start>
                  <v-flex xs3 md3 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Item</span>
                  </v-flex>
                  <v-flex xs2 md2 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Stock Details</span>
                  </v-flex>
                  <v-flex xs2 md2 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Pricing</span>
                  </v-flex>
                  <v-flex xs1 md1 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Offer</span>
                  </v-flex>
                  <v-flex xs2 md2 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Added On</span>
                  </v-flex>
                  <v-flex xs1 md1 text-left>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Status</span>
                  </v-flex>
                  <v-flex xs1 md1 text-center>
                    <span style="color: #000; font-family: poppinsmedium; font-size: 13px;">Actions</span>
                  </v-flex>
                </v-layout>
              </div>

              <!-- List Items -->
              <template v-for="(item, i) in products">
                <div :key="item._id" style="padding: 24px;">
                  <InventoryItem v-bind:storage="item" @stepper="winStepper" />
                </div>
                <v-divider :key="'div-' + i" v-if="i !== products.length - 1" color="#eaeaea"></v-divider>
              </template>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="pages > 1">
          <v-flex xs12>
            <v-pagination
              v-model="currentPage"
              :length="pages"
              :total-visible="7"
              color="#3ea56e"
            ></v-pagination>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="products.length < 1">
          <v-flex xs12>
            <span
              style="
                font-family: poppinsregular;
                font-size: 25px;
                color: #000000;
              "
            >
              Oops! No Products Found
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import SubCategorySlider from "./subCategorySlider";
import InventoryItem from "./inventoryItem";
export default {
  components: {
    // SubCategorySlider,
    InventoryItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      pages: 1,
      count: 5,
      pageLength: 0,
      // pages:null,
      productTotalCount: 0,
      products: [],
      activeCount: 0,
      inactiveCount: 0,
      totalCount: 0,
      productData: {},
      listStatus: "All",
      searchKey: null,
    };
  },
  watch: {
    listStatus() {
      this.getData();
    },
    currentPage() {
      this.$router.push({
        path: "/Seller/Inventory",
        query: {
          page: this.currentPage,
        },
      });
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getData();
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/view/seller/products",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // keyword: this.$route.query.searchKey,
          subcategory: this.$route.query.subcategory,
          // status: this.listStatus,
          count: this.count,
          page: this.$route.query.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            // this.pageLength = Math.ceil(response.data.totalLength / this.count);
            this.pages = response.data.pages;
            this.activeCount = response.data.activecount;
            this.inactiveCount = response.data.inactivecount;
            this.totalCount = response.data.totalcount;
            this.productTotalCount = response.data.totalcount;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
